<div class="admin-container">
    <div class="title-container">
        <span class="title"
            >Account Migration
            <div class="dot">
                ?
            </div>
            <span class="tooltip-text">{{ this.tooltipMessage }}</span>
        </span>
    </div>
    <div class="action-container">
        <lsq-button
            class="migrate-button"
            appearance="secondary"
            [disabled]="isInvitedOrMigrated()"
            (buttonClick)="openMigrationModal()"
            >Migrate User to FastTrack</lsq-button
        >
    </div>
    <div class="flex-container align-left">
        <div class="flex-field">
            <span class="size-text label-grid">CLIENT NUMBER</span>
            <span class="size-text label-content-grid">
                <lsq-smart-truncate
                    [value]="this.prospect.migration?.clientNumber || '--'"
                    [popoverValue]="this.prospect.migration?.clientNumber || ''"
                ></lsq-smart-truncate
            ></span>
        </div>

        <div class="flex-field">
            <span class="size-text label-grid">MIGRATION DATE</span>
            <span class="size-text label-content-grid">
                <lsq-smart-truncate
                    [value]="this.parseDate(this.prospect.migration?.migrationDate)"
                    [popoverValue]="this.parseDate(this.prospect.migration?.migrationDate)"
                ></lsq-smart-truncate
            ></span>
        </div>

        <div class="flex-field">
            <span class="size-text label-grid">INITIATED BY</span>
            <span class="size-text label-content-grid">
                <lsq-smart-truncate
                    [value]="this.prospect.migration?.initiatedBy || '--'"
                    [popoverValue]="this.prospect.migration?.initiatedBy || ''"
                ></lsq-smart-truncate>
            </span>
        </div>
    </div>
</div>
